export class ThemeHelper {
    public setBootstrapTheme(theme: "light" | "dark"): void {
        document.documentElement.setAttribute("data-bs-theme", theme);
    }

    public getCurrentTheme(): "light" | "dark" {
        const attr = document.documentElement.getAttribute("data-bs-theme");
        return attr === "light" ? "light" : "dark";
    }

    public getOSPreference(): boolean {
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
}